import { z } from 'zod';
// Deep imports: the form language's environment loads this module through
// `topic_type_def.ts`, so the language's barrel is not yet loaded when it runs.
import type { Expression } from '@/modules/form/lang/expression';
import { TokenLogic } from '@/modules/form/lang/token';

const NAME = /^_?[A-Za-z][A-Za-z0-9_]*$/;

/**
 * The schema of a topic type's `definitions.yaml`: the names it defines for
 * its sharing forms, each a `define` statement. `define` is the name, any
 * name, `_`-prefixed or not; `expr` is the expression it is bound to,
 * written as a `{…}` token's source and read into an `Expression`; and
 * `doc`, when given, is what a person calls the value. Which names a define
 * may take and read is checked in the environment it runs in, by
 * `topic_type_def.test.ts`.
 */
export const DEFINITIONS_SCHEMA = z.array(
  z.strictObject({
    define: z.string().regex(NAME, 'must be a name'),
    expr: z.string().transform((source, ctx): Expression => {
      const reading = TokenLogic.read(source);
      if (!reading.ok) {
        ctx.addIssue({
          code: 'custom',
          message: `${source} cannot be read: ${reading.reason}`,
        });
        return z.NEVER;
      }
      return reading.expression;
    }),
    doc: z.string().min(1).optional(),
  })
);
